import { saveChartAction, openPublishModalAction } from '../actions/chartEditor';
import store from '../../../redux/store';
import { merge, toCSV, toMapCSV } from 'editor/core/highcharts-editor';
import { createSelector } from 'reselect';
import { cloneDeep } from 'lodash';

export const getChartConfig = (state) => state.chartEditorPage;

const getAssignDataFields = (options) => {
  let all = [];

  options.forEach((option) => {
    let arr = {};
    Object.keys(option).forEach((key) => {
      if (key === 'hidden' || option[key].value === '' || option[key].value === null) return;
      arr[key] = option[key].value;
    });
    all.push(merge({}, arr));
  });

  return all;
};

const getCSV = createSelector([(state) => state.dataOptions, (state, category) => category], (dataOptions, constr) => {
  const csvParser = constr === 'Map' ? toMapCSV : toCSV;
  return csvParser(dataOptions);
});

export const getAggregatedChartConfig = (state, chartEditor) => {
  let dataProvider = {
    ...state.aggregatedOptions.data,
    assignDataFields: getAssignDataFields(state.seriesAssigns)
  };
  const constr = chartEditor.constr ?? 'Chart';
  if (dataProvider.csv) {
    dataProvider.csv = getCSV(state, constr);
  }

  // Live data
  const csvUrl = state?.aggregatedOptions?.data?.csvURL;
  const rowsUrl = state?.aggregatedOptions?.data?.rowsURL;
  const columnsUrl = state?.aggregatedOptions?.data?.columnsURL;
  if (csvUrl || rowsUrl || columnsUrl) {
    // eslint-disable-next-line no-nested-ternary
    const key = csvUrl ? 'csvURL' : rowsUrl ? 'rowsURL' : 'columnsURL';
    dataProvider = {
      liveData: {
        [key]: csvUrl || rowsUrl || columnsUrl
      }
    };
  }

  // Google sheet
  const googleSheetKey = state.aggregatedOptions?.data?.googleSpreadsheetKey;
  if (googleSheetKey) {
    dataProvider = {
      googleSpreadsheet: {
        googleSpreadsheetKey: googleSheetKey,
        googleSpreadsheetRange: state.aggregatedOptions.data.googleSpreadsheetRange
      }
    };
  }

  let plugins = cloneDeep(state.plugins);
  plugins.cssModules = state.cssModules;

  return {
    options: merge({}, state.customizedOptions ?? {}),
    settings: {
      dataProvider,
      plugins,
      template: merge({}, state.templateMeta),
      templateDataSettings: state.templateDataSettings ?? {},
      constructor: [constr]
    },
    theme: {
      ...(state.themeMeta ?? {}),
      options: merge({}, state.themeOptions ?? {})
    },
    template: {
      ...(state.templateOptions[0] ?? {})
    },
    customCode: chartEditor.customCodeStr
  };
};

export const getNavActions = (checkPermission, state, userProps, history, anonymous) => {
  let actions = [];

  if (checkPermission('create_chart') || anonymous) {
    actions.push({
      text: 'Save',
      onClick: () => {
        store.dispatch(
          saveChartAction({
            reload: true,
            callback: () => {
              if (state.projectConfig.published) {
                store.dispatch(openPublishModalAction({}));
              }
            },
            history
          })
        );
      }
    });
  }

  if (anonymous || (checkPermission('publish') && userProps && userProps.features.indexOf('publish') > -1)) {
    actions.push({
      text: 'Publish',
      className: 'publish-btn',
      onClick: () => {
        store.dispatch(openPublishModalAction({}));
      }
    });
  }

  return actions;
};
